import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Chip,
  Box,
  MenuItem,
  Typography,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export default function FormMultipleSelect({
  name,
  label,
  sublabel,
  options,
  disabled,
  size,
  maxSelect,
  helperStyles,
}) {
  const { control } = useFormContext();

  const handleDelete = (valueToRemove, currentValues, onChange) => {
    onChange(currentValues.filter((v) => v !== valueToRemove));
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { error },
      }) => {
        const currentValue = value || [];
        return (
          <FormControl size={size} fullWidth variant="outlined" error={!!error}>
            {label && (
              <InputLabel id={`${name}-multiple-label`}>{label}</InputLabel>
            )}
            <Select
              labelId={`${name}-multiple-label`}
              id={`${name}-multiple`}
              multiple
              displayEmpty={!label}
              disabled={disabled}
              value={currentValue}
              onChange={onChange}
              onBlur={onBlur}
              inputRef={ref}
              error={!!error}
              size={size}
              label={label}
              renderValue={() => {
                if (value && value?.length > 0) {
                  return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {value?.map((val) => {
                        const opt = options.find((o) => o.name === val);
                        return (
                          <Chip
                            key={val}
                            label={opt?.name || val}
                            size="small"
                            onDelete={() =>
                              handleDelete(val, currentValue, onChange)
                            }
                            onMouseDown={(e) => e.stopPropagation()}
                          />
                        );
                      })}
                    </Box>
                  );
                }

                if (!label && !value)
                  return (
                    <Typography color="text.disabled" fontSize="14px">
                      Selecciona tu respuesta
                    </Typography>
                  );
              }}
            >
              {options.map((option) => {
                const isSelected = currentValue.includes(option.name);
                const isMaxed =
                  maxSelect && currentValue.length >= maxSelect && !isSelected;
                return (
                  <MenuItem
                    key={option.id}
                    value={option.name}
                    disabled={isMaxed}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        width: '100%',
                      }}
                    >
                      {isSelected ? (
                        <CheckIcon
                          sx={{ ml: 1, fontSize: 18, color: 'primary.main' }}
                        />
                      ) : (
                        <Box sx={{ width: '25px' }} />
                      )}
                      <Typography variant="body2">{option.name}</Typography>
                    </Box>
                  </MenuItem>
                );
              })}
            </Select>
            {(!!error || sublabel) && (
              <FormHelperText error={!!error} sx={{ ...helperStyles }}>
                {error?.message ? error.message : sublabel}
              </FormHelperText>
            )}
          </FormControl>
        );
      }}
    />
  );
}

FormMultipleSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.any, name: PropTypes.string }),
  ),
  disabled: PropTypes.bool,
  size: PropTypes.string,
  maxSelect: PropTypes.number,
};

FormMultipleSelect.defaultProps = {
  label: '',
  options: [],
  disabled: false,
  size: 'medium',
  maxSelect: null,
};
